import AttachmentFieldHandler from './handlers/AttachmentFieldHandler';
import BasicFieldHandler from './handlers/BasicFieldHandler';
import CalculatedFieldHandler from './handlers/CalculatedFieldHandler';
import ChoiceFieldHandler from './handlers/ChoiceFieldHandler';
import DateTimeFieldHandler from './handlers/DateTimeFieldHandler';
import InteractiveFieldHandler from './handlers/InteractiveFieldHandler';
import NumericFieldHandler from './handlers/NumericFieldHandler';
import SelectorFieldHandler from './handlers/SelectorFieldHandler';
import SpecialFieldHandler from './handlers/SpecialFieldHandler';
import ValidationFieldHandler from './handlers/ValidationFieldHandler';

export default class FieldHandlerFactory {
  static handlers = [
    NumericFieldHandler,
    SelectorFieldHandler,
    ChoiceFieldHandler,
    DateTimeFieldHandler,
    AttachmentFieldHandler,
    CalculatedFieldHandler,
    InteractiveFieldHandler,
    ValidationFieldHandler,
    BasicFieldHandler,
    SpecialFieldHandler, // Fallback handler for all other types
  ];

  static getHandler(fieldType, baseConfig, configData, dependency) {
    for (const HandlerClass of this.handlers) {
      if (HandlerClass.supportedTypes?.includes(fieldType)) {
        return new HandlerClass(baseConfig, configData, dependency);
      }
    }

    // Special handler serves as fallback for any unsupported types
    return new SpecialFieldHandler(baseConfig, configData, dependency);
  }

  static registerHandler(HandlerClass) {
    // Insert before SpecialFieldHandler (which is the fallback)
    this.handlers.splice(this.handlers.length - 1, 0, HandlerClass);
  }
}
